import React, { useEffect, useState } from "react";
import { Grid, Button } from "semantic-ui-react";
import { Field } from "redux-form";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";

const AttractionItenery = ({
  fields,

  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
    getAttractionList();
  }, []);

  const [attractionList, setAttractionList] = useState([]);

  const getAttractionList = async () => {
    await axios
      .post(
        "https://parmartours.com:8443/parmartour/v1.0/getAttractionListB2C",
        { attractionId: 1 }
      )
      .then((res) => {
        console.log(res.data);
        const attractionList = res.data.map((item) => ({
          text: item.attName,
          value: item.attractionsId,
        }));

        setAttractionList(attractionList);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <ul>
      {fields.map((item, attArrindex) => (
        <Grid
          columns={7}
          style={{
            backgroundColor: "#92a8d1",
            marginBottom: "20px",
          }}
        >
          <Grid.Row>
            <Grid.Column>
              <Field
                name={`${item}.attractionId`}
                options={attractionList}
                component={renderOptionField}
                label="Attraction Name"
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name={`${item}.quantity`}
                type="text"
                component={renderTextField}
                label="Quantity"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.price`}
                type="text"
                component={renderTextField}
                label="Price"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.transType`}
                type="text"
                component={renderTextField}
                label="Transport Type"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.guideName`}
                type="text"
                component={renderTextField}
                label="Guide Name"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={`${item}.guideCharge`}
                type="text"
                component={renderTextField}
                label="Guide Charge"
              />
            </Grid.Column>

            <Grid.Column>
              <br />
              <li key={attArrindex} style={{ listStyleType: "none" }}>
                {attArrindex != 0 && (
                  <Button
                    type="button"
                    floated="left"
                    negative
                    onClick={() => fields.remove(attArrindex)}
                  >
                    X
                  </Button>
                )}
                {fields.length - 1 === attArrindex && (
                  <Button
                    type="button"
                    positive
                    floated="right"
                    onClick={() => fields.push({})}
                  >
                    Add Attraction
                  </Button>
                )}
              </li>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ))}
      <br />
      {(touched || submitFailed) && error && <span>{error}</span>}
    </ul>
  );
};

export default AttractionItenery;
